import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Services } from "src/app/components/wrapper.component";
import publicHelpers from "globals/helpers/public-helpers";
import { JoiEvent, LabelObject } from "globals/store/events.data";
import { performerDisplayTypes } from "src/app/store/performers.era"
import { Session, SessionType } from 'globals/store/programs.data';
import { IconComponent } from "src/app/components/icon/icon.component";
import { JoiInputComponent } from "src/app/components/joi-input/joi-input.component";
import { CommonModule } from "@angular/common";
import { LabelItemComponent } from "src/app/components/label-marker/label-item.component";
import { MatButtonModule } from "@angular/material/button";
import { CdkDragHandle } from "@angular/cdk/drag-drop";
import { PerformersComponent } from "src/app/components/performers/performers.component";
import { InputEditorComponent } from "src/app/components/joi-input/input-editor";

@Component({
    selector: 'session-card',
    template: `

<ng-template #addSessionBetweenTemplate let-top="top">
  <div class="trigger_wrapper">
    <div class="bottom_trigger"[ngClass]="{ wide: wide }" ></div>
    <div class="add_session_between"> 
      <button matButton class="plain" (click)="addBetween.emit({ top: top, type: 'session' })">+ Add a session</button>
      <div style="flex:1;"></div>
      <button matButton class="plain" (click)="addBetween.emit({ top: top, type: 'break' })">+ Add out-of-session</button>
    </div>
  </div>
</ng-template>
@if(!!topPopin || placeholder){
  <ng-container [ngTemplateOutlet]="addSessionBetweenTemplate" [ngTemplateOutletContext]="{ top: true }"></ng-container>
}
<div *ngIf="placeholder" class="no_sessions">
No Sessions
</div>
@if(!placeholder){
<div class="session-wrapper" [ngClass]="{ wide: wide }">
  <div class="time_container" [ngClass]="{ review: session.contentStatus === 'Review', in_progress: session.contentStatus === 'In Progress', confirmed: session.contentStatus === 'Confirmed', disabled: !fullAccess || dragging || !canDrag}">
    <div class="session_handle sess_handle desktop" [ngClass]="{ draggable: canDrag }">
      <icon class="sess_handle"  matIcon="drag_indicator" cdkDragHandle ></icon> <!---->
    </div>
    <div [class]="'times ' + (session.excessive ? 'excessive_'+session.excessive : '' )">
      <div class="time start">{{session.start}}</div>
      <div class="time end">{{session.end}}</div>
    </div>
  </div>
  <div class="info_container" [ngClass]="{narrow_info: !wide, break: session.type === 'break' }" (click)="editSession.emit($event)">
    <div class="secondary" *ngIf="!!secondaryTimeString">{{ secondaryTimeString }}</div>
    <div style="display: flex;">
      <div *ngIf="session.contentStatus === 'Confirmed'" class="confirmed_tick">
        <icon icon="tick_12px"></icon>
      </div>
      <joi-input [model]="session.title" (joiChange)="services.programService.updateSessionTitle(programId, $event, session.id, session)" [disabled]="!fullAccess || dragging" [placeholder]="title_placeholder" [ngClass]="{'on-grey':session && session.type === 'break'}" class="title desktop non-popup-trigger" [focusOnNew]="true" type="textarea" [autoSelect]="true"></joi-input>
      <div style="flex-grow:1"></div>
      <icon *ngIf="session.flag" icon="flagon" class="flagon"></icon>
    </div>
    <div class="title mobile" [ngClass]="{hand: session.type === 'session'}">
      {{session.title}}
      <span *ngIf="!session.title">{{ title_placeholder }}</span>
    </div>
    <div class="duration_container" [ngClass]="{hand: session.type === 'session'}">
      <joi-input [model]="session.duration" (click)="$event.stopPropagation()" (joiChange)="services.programService.parseSessionDurationAndSave(session, $event, programId)" [disabled]="!fullAccess || dragging" class="duration non-popup-trigger" [maxlength]="4" [placeholder]="'0'" [autoSelect]="true"></joi-input>
      <div class="duration_units">minute{{session.duration !== 1 ? 's' : ''}}</div>
      <div *ngIf="!!session.presentationAssets?.length" class="attachment">
        <icon [icon]="'PRESENTATION18'"></icon>
        <span>{{session.presentationAssets?.length}}</span>
      </div>
      <icon *ngIf="session.description" matIcon="subject"></icon>
      <icon *ngIf="!!session.notes || !!session.files?.length" matIcon="assignment"></icon>
    </div>
    <div class="labels_content" *ngIf="session.labels && session.labels.length > 0">
      <ng-container *ngFor="let id of session.labels">
        <label-item *ngIf="labels && labels[id] as lbl" [color]="lbl.color" [label]="lbl.label"></label-item>
      </ng-container>
    </div>
    <div class="description_input_holder" *ngIf="wide" [ngClass]="{ disabled: !isProgram }">
        <input-editor
          class="description desktop non-popup-trigger"
          [disabled]="!isProgram"
          [object]="session"
          [prop]="'description'"
          [placeholder]="!isProgram ? 'No description' : 'Session description...'"
          (changed)="updateSessionDescription()"
        ></input-editor> 
    </div> 
    <performers *ngIf="session.performerIds && session.performerIds.length" [performerIds]="session.performerIds" [initialLimit]="5" [displayType]="performerDisplayType" [sessionId]="session.id"></performers>
    <!-- <static-sponsor-cards [initialLimit]="5" *ngIf="!!session.sponsorIds?.length" [sponsors]="event.sponsors" [sponsorIds]="session.sponsorIds"></static-sponsor-cards>-->
    <div class="edit_button_container" [ngClass]="{hand: session.type === 'session'}">
      <icon *ngIf="session.type !== 'session' && fullAccess && !dragging" (click)="deleteBreak.emit($event)" class="edit" icon="delete_24px">
      </icon>
    </div>
  </div>
</div>
}
<ng-container *ngIf="!!bottomPopin" [ngTemplateOutlet]="addSessionBetweenTemplate" [ngTemplateOutletContext]="{ top: false }"></ng-container>


  `,
    styleUrls: ['./session-card.scss'],
    standalone: true,
    imports: [IconComponent, InputEditorComponent, MatButtonModule, JoiInputComponent, CommonModule, LabelItemComponent, CdkDragHandle, PerformersComponent]
})
export class SessionCardComponent {
  @Input() session: Session
  @Input() wide: boolean
  @Input() placeholder = false
  @Input() placeholderText: string
  @Input() isProgram = false

  @Input() fullAccess: boolean
  @Input() dragging: boolean
  @Input() canDrag = false

  @Input() programId: string
  @Input() ready: boolean
  @Input() event: JoiEvent
  @Input() labels?: LabelObject  
  @Input() secondaryTimeString: string
  @Input() topPopin: boolean
  @Input() bottomPopin: boolean

  services = Services
  @Output() addBetween: EventEmitter<{ top: boolean, type: SessionType }> = new EventEmitter()
  @Output() editSession: EventEmitter<Event> = new EventEmitter()
  @Output() deleteBreak: EventEmitter<Event> = new EventEmitter()

  performerDisplayType = performerDisplayTypes.listOnly
  helpers = publicHelpers;
  title_placeholder = 'Session title...'

  updateSessionDescription() {
    this.services.programService.updateSessionDescription(this.programId, this.session.description, this.session.id)
  }
  
}
